import React, {forwardRef, useEffect, useRef, useState} from "react";
import {generateRandomPageKey, generateUUID2, getImagePathWithTheme,
    imgPathPerfix, isDarkMode, isStringNullOrEmpty, removeHtmlTags} from "@/utils";
import {getCardDoc, getCardList, updateCard} from "@model/card";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {EditorContent, useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Import} from "@tiptap-pro/extension-import";
import {Export} from "@tiptap-pro/extension-export";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import {Color} from "@tiptap/extension-color";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import Placeholder from "@tiptap/extension-placeholder";
import FontSize from "tiptap-extension-font-size";
import {Indent} from "@/components/EditorV2/indent";
import Link from "@/components/EditorV2/extension-link/src";
import ImageT from "@tiptap/extension-image";
import Image from "@/components/EditorV2/imgResize";
import {Hyperlink} from "@docs.plus/extension-hyperlink";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Blockquote from "@tiptap/extension-blockquote";
import {FontFamily} from "@tiptap/extension-font-family";
import DeeplinkNode from "@/components/Deeplink/DeeplinkNode";
import {t} from "i18next";
import {ConfigProvider, Input, Spin, Tabs} from "antd";
import {getNoteJsonDoc, getNoteList} from "@model/note";
import DirectoryTree from "antd/es/tree/DirectoryTree";
import Icon from "@ant-design/icons";
import {TreeProps} from "antd/es/tree";
import {FROM_LINK_TO_PROJECT, MAX_Z_INDEX} from "@/Const";
import {getTiptapExtension} from "@/components/EditorV2/TiptapTiptapExtension";
import './SmallEditStyle.css'
import {filterNodes, loopAllNode} from "@/TreeUtils";
import {debugLog} from "@/LogUtils";
import {createPortal} from "react-dom";

let editor:any,editorJournal:any;

let mActiveKey:string = 'card';
const PopupCardList = forwardRef((props:{position:any,onItemSelect:any}, ref) => {
    const [cardTitle, setCardTitle] = useState('');
    const [arrayDatas, setArrayDatas] = useState([]);
    const [arrayProjects,setArrayProjects] = useState([]);
    const [arrayJournal,setArrayJournal] = useState([]);
    const [searchKey,setSearchKey] = useState('')
    const [tabKey,setTableKey] = useState('card');
    const [arrayTreeData,setArrayTreeData] = useState([]);

    const [previewCard,setPreviewCard] = useState(null);

    const [selectProject,setSelectProject] = useState(null);
    const [selectJournal,setSelectJournal] = useState(null);
    const [isSearching,setIsSearching] = useState(false);

    const mLastSearchTimeoutId = useRef<any>(0);

    const inputSearchRef = useRef(null);
    const mSearchKey = useRef<any>(null);
    const mPageNum = useRef(0);

    const tabItems = [
        {
            key:'card',
            label:t('Card'),
            children:''
        },
        {
            key:'journal',
            label:t('Journal'),
            children:''
        },
        {
            key:'project',
            label:t('Projects'),
            children:''
        },
    ]

    editor = useEditor({
        autofocus:false,
        injectCSS: true,
        editable:false,
        extensions:getTiptapExtension(),
        editorProps: {
            attributes: {
                // class: '',
            },
        },
        onCreate(options){
            const nIndex = arrayDatas.findIndex(p=>p.isHover);
            if (nIndex >= 0){
                showPreview(arrayDatas[nIndex]);
            }
            updateEditDefaultSize();
            options.editor.commands.setFontSize('12px');

        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    editorJournal = useEditor({
        autofocus:false,
        injectCSS: true,
        editable:false,
        extensions: [
            StarterKit,
            Text,
            TextStyle,
            Color,
            Heading.configure({
                levels: [1, 2, 3,4,5,6],
            }),
            Paragraph,
            Highlight.configure({ multicolor: true }),
            TextAlign.configure({
                types: ["heading", "paragraph"],
            }),
            Underline,
            // getBlockMenu(),
            Placeholder.configure({
                placeholder: '',
            }),
            FontSize,
            Indent,
            Link.configure({
                autolink:false,
                linkOnPaste:false,
            }),
            ImageT,
            Image.configure({
                allowBase64: true
            }),
            Hyperlink.configure({
                HTMLAttributes: {
                    target: '_self'
                }
            }),
            TaskList,
            TaskItem.configure({
                nested: true,
            }),
            HorizontalRule,
            Blockquote,
            Hyperlink.configure({
            }),
            FontFamily,
            DeeplinkNode,
        ],
        editorProps: {
            attributes: {
                // class: '',
            },
        },
        onCreate(options){
            const nIndex = arrayJournal.findIndex(p=>p.isHover);
            if (nIndex >= 0){
                showPreview(arrayDatas[nIndex]);
            }
            updateEditDefaultSize();
            options.editor.commands.setFontSize('12px');

        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    /**
     * 键盘事件.
     * @param event
     */
    function onKeyDown(event:any){
        // debugLog('actionProperties',event);

        if (mActiveKey == 'card'){
            onKeyEvent(event,arrayDatas);
        }else if (mActiveKey == 'project'){
            onKeyEvent(event,arrayProjects);
        }else if (mActiveKey == 'journal'){
            onKeyEvent(event,arrayJournal);
        }
    }

    const onKeyEvent = (event:any,arrayDatas)=>{
        if (event.code == KEYS.ARROW_DOWN){
            var nIndex = arrayDatas.findIndex(p=>p.isHover);
            var arrayNew = [...arrayDatas];
            arrayNew.forEach(p=>{
                p.isHover = false;
            })
            if (nIndex >= arrayDatas.length-1){
                nIndex = 0;
            }else{
                nIndex++;
            }
            arrayNew[nIndex].isHover = true;

            //显示这个的预览
            showPreview(arrayNew[nIndex]).then(res=>{
                setNewDatasAndScrollTo(arrayNew,nIndex);
            });
            event.preventDefault();
            event.stopPropagation();
        }else if (event.code == KEYS.ARROW_UP){
            var nIndex = arrayDatas.findIndex(p=>p.isHover);
            var arrayNew = [...arrayDatas];
            arrayNew.forEach(p=>{
                p.isHover = false;
            })
            if (nIndex == 0){
                nIndex = arrayDatas.length -1;
            }else{
                nIndex--;
            }
            arrayNew[nIndex].isHover = true;
            setArrayDatas(arrayNew);

            //显示这个的预览
            showPreview(arrayNew[nIndex]).then(res=>{
                setNewDatasAndScrollTo(arrayNew,nIndex);
            });
            event.preventDefault();
            event.stopPropagation();
        }else if (event.code == KEYS.ENTER){
            //选择这个...
            const nIndex = arrayDatas.findIndex(p=>p.isHover);
            onSelectItem(arrayDatas[nIndex]);
            event.preventDefault();
            event.stopPropagation();
        }
    }

    const setNewDatasAndScrollTo = (arrayNew:any,nIndex:any)=>{
        if (mActiveKey == 'card'){
            setArrayDatas(arrayNew);
        }else if (mActiveKey == 'project'){
            setArrayProjects(arrayNew);
        }else if (mActiveKey == 'journal'){
            setArrayJournal(arrayNew);
        }
        scrollToIndex(nIndex);
    }

    //显示预览
    async function showPreview(item:any){
        updateEditDefaultSize();

        if (item.type == 'card' || item.type == 'journal'){
            if (!item.doc){
                item.doc = await getCardDoc(item.id);
            }
        }
        if (mActiveKey == 'card'){
            setCardTitle(item.name);
            editor?.commands.setContent(item.doc);
        }else if (mActiveKey == 'project'){
            setSelectProject(item);
        }else if (mActiveKey == 'journal'){
            setSelectJournal(item);
            editorJournal?.commands.setContent(item.doc);
        }
        if (item.type == 'card'){
            setPreviewCard(item);
        }
    }


    useEffect(() => {
        setSearchKey('');
        mSearchKey.current = '';
        updateList(true);

        // projectList();
        //
        // journalList();

        setTimeout(()=>{
            inputSearchRef.current?.focus();
        },100)
    }, [])

    useEffect(()=>{
        document.body.addEventListener('keydown',onKeyDown);

        return ()=>{
            document.body.removeEventListener('keydown',onKeyDown);
        }
    })

    /**
     * 滚动到索引
     * @param nIndex
     */
    const scrollToIndex = (nIndex:number)=>{
        let div = document.getElementById('div-popup-card-list');
        if (tabKey == 'project'){
            div = document.getElementById('div-popup-project-list');
        }else if (tabKey == 'journal'){
            div = document.getElementById('div-popup-journal-list');
        }
        if (div){
            if (nIndex > 3){
                div.scrollTo(0,(nIndex-3)*60 + 16)
            }else{
                div.scrollTo(0,0)
            }
        }
    }

    const updateList = (isFirstLoad:boolean = false) => {

        getCardList(mPageNum.current,0,'card','',mSearchKey.current).then(res=>{
            //第一个显示new card
            var arrayNewDatas:any = [];
            if (mPageNum.current > 0 && !mSearchKey.current){
                arrayNewDatas.push(...arrayDatas);
            }
            if (mPageNum.current == 0){
                arrayNewDatas.push({
                    id:'createNewCard',
                    name:t("Create new card"),
                    type:'card',
                    doc:'',
                    isHover:true,
                })
            }

            arrayNewDatas.push(...res);

            if (isFirstLoad && arrayNewDatas.length > 0){
                arrayNewDatas[0].isHover = true;
            }
            //显示预览
            const nIndex = arrayNewDatas.findIndex(p=>p.isHover);
            if (nIndex >= 0){
                showPreview(arrayNewDatas[nIndex]);
            }
            setIsSearching(false);

            setArrayDatas(arrayNewDatas);
        })
    }

    //项目列表
    const projectList = ()=>{
        //仅列表...
        // getNoteList().then((res:any)=>{
        //     res = res.sort((a,b)=>{
        //         return b.updateTime - a.updateTime;
        //     })
        //     if (mszSearchKey){
        //         res = res.filter(p=>p.name.indexOf(mszSearchKey) != -1);
        //     }
        //     if (res.length > 0){
        //         res[0].isHover = true;
        //         setSelectProject(res[0]);
        //     }
        //     setArrayProjects(res);
        // })

        //tree
        getNoteList().then(async (res)=>{
            var arrayNew:any = [];
            // if (from != FROM_LINK_TO_PROJECT){
            //     arrayNew.push({
            //         id:generateRandomPageKey(),
            //         showName:t("Create project")+' ""',
            //         name:'',
            //         isCreateNew:true,
            //         isChecked:true
            //     })
            // }
            // arrayNew.push(...res);
            setArrayDatas(arrayNew);

            var arrayNewTreeData:any = [];
            for (let i=0;i<res.length;i++){
                let bFind = false;
                const item = res[i];
                const jsonDoc = await getNoteJsonDoc(item.id);
                if (!jsonDoc)continue;
                const treeData = {
                    id:item.id,
                    key:item.id,
                    title:item.name,
                    icon:null,
                    isProject:true,
                }
                // if (item.name?.toLowerCase().includes(mszSearchKey)){
                //     bFind = true;
                // }
                //所有条目定入项目的ID
                loopAllNode(jsonDoc.canvas,(node)=>{
                    node.id = item.id
                })

                treeData.children = [];
                treeData.children.push(...jsonDoc.canvas);
                arrayNewTreeData.push(treeData);

                // if (jsonDoc.canvas?.length > 1){
                //     for (let j=0;j<jsonDoc.canvas.length;j++){
                //         if (jsonDoc.canvas[j].title?.toLowerCase().includes(mszSearchKey)){
                //             bFind = true;
                //             treeData.children.push({
                //                 isChild:true,
                //                 id:item.id,
                //                 key:jsonDoc.canvas[j].key,
                //                 title:jsonDoc.canvas[j].title
                //             })
                //         }
                //     }
                // }
                // if (bFind){
                //     arrayNewTreeData.push(treeData);
                // }
            }

            if (mSearchKey.current){
                arrayNewTreeData = filterNodes(arrayNewTreeData,mSearchKey.current);
            }

            setIsSearching(false);
            setArrayTreeData(arrayNewTreeData);

            onSetTreeHover();
        })
    }


    //日记列表
    const journalList = ()=>{
        getCardList(-1,0,'journal','',mSearchKey.current).then((res:any)=>{
            if (res.length > 0){
                res[0].isHover = true;
                setSelectJournal(res[0]);
                showPreview(res[0]);
            }
            setIsSearching(false);
            setArrayJournal(res);
        })
    }

    const onSelectItem = (item:any)=>{
        if (item){
            var newCard = {...item};
            if (item.id == 'createNewCard'){
                newCard.id = generateUUID2();
                newCard.name = '';
                updateCard(newCard).then(res=>{
                    if (props.onItemSelect){
                        props.onItemSelect(newCard);
                    }
                })
            }else{
                if (props.onItemSelect){
                    props.onItemSelect(item);
                }
            }
        }
    }

    const updateEditDefaultSize = ()=>{
        setTimeout(()=>{
            const div = document.getElementById('editor-small-preview');
            if (div){
                const editDiv = div.childNodes[0];
                editDiv?.classList.remove('ProseMirror');
                editDiv.classList.add('ProseMirror-card-small')
            }

            const divJournal = document.getElementById('editor-small-preview-journal');
            if (divJournal){
                const editDivJournal = divJournal.childNodes[0];
                editDivJournal?.classList.remove('ProseMirror');
                editDivJournal.classList.add('ProseMirror-card-small')
            }
        },100)
    }

    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
        console.log(info.node);
        if (!info.node.isProject && (info.node.isFolder || info.node.children))return;

        onSelectItem(info.node);
    });

    const onSetTreeHover = ()=>{
        setTimeout(()=>{
            const div = document.getElementById('div-shit-shit-ant-tree');
            if (div){
                const arrayShitTrees = div.getElementsByClassName('ant-tree-list-holder-inner');
                for (let i=0;i<arrayShitTrees.length;i++){
                    const ddddd = arrayShitTrees[i];
                    ddddd.classList.add(isDarkMode()?'ant-tree-list-holder-inner-shit-ant-tree-dark':'ant-tree-list-holder-inner-shit-ant-tree-light')
                }
            }
        },100)
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit"}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey.current = '';
                            mPageNum.current = 0;
                            doSearch();

                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    const doSearch = ()=>{
        if (tabKey == 'card') {
            setCardTitle('');
            updateList(true);
        } else if (tabKey == 'journal') {
            setSelectJournal(null);
            journalList();
        } else {
            setSelectProject(null);
            projectList();
        }
    }


    return createPortal(
        <div style={{position:'fixed',left:'0',top:'0',height:'100%',width:'100%',zIndex: MAX_Z_INDEX+9999,}} onClick={()=>{
            window.closePopupCardList();
        }}>
            <div  id={'div-shit-shit-ant-tree'} style={{
                position: "fixed",
                zIndex: MAX_Z_INDEX,
                left: props.position.left,
                top: props.position.top,
                width: '475px',
                height: '362px',
                background: 'var(--dialog-background-color)',
                fontSize: '12px',
                boxShadow: 'var(--dialog-box-shadow)',
                padding: '6px',
                borderRadius: '8px',
            }} onClick={(event)=>{
                event.preventDefault();
                event.stopPropagation();
            }}>
                <Input ref={inputSearchRef} placeholder={t("Search cards")}
                       suffix={renderSuffix()}
                       className={'input-border'} value={searchKey}
                       onChange={(event) => {
                           setSearchKey(event.currentTarget.value);
                           mSearchKey.current = event.currentTarget.value.toLowerCase();
                           mPageNum.current = 0;
                           setIsSearching(true);
                           //清除上一次的计时
                           clearTimeout(mLastSearchTimeoutId.current);
                           mLastSearchTimeoutId.current = setTimeout(()=>{
                               doSearch()
                               clearTimeout(mLastSearchTimeoutId.current);
                           },1500);
                       }}
                       style={{height: '32px', width: '100%', background: 'var(--input-background-color)!important'}}/>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                /* 这里是你的组件 token */
                                fontSize: 12,
                            },
                        },
                    }}>
                    <Tabs style={{marginTop: '12px', overflow: 'hidden', padding: '0 12px'}}
                          tabBarStyle={{borderBottom: '0px solid var(--tab-line-color)'}} className='font-size-12'
                          items={tabItems} activeKey={tabKey} onChange={(activeKey) => {
                        mActiveKey = activeKey;
                        setTableKey(activeKey);
                        if (activeKey == 'card') {
                            setCardTitle('');
                            updateList(true);
                        } else if (activeKey == 'journal') {
                            setSelectJournal(null);
                            journalList();
                        } else {
                            setSelectProject(null)
                            projectList();
                        }
                    }}/>
                </ConfigProvider>

                {
                    //region card
                    tabKey == 'card' &&
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '260px auto',
                        height: '280px',
                    }}>
                        <div id={'div-popup-card-list'} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            borderRight: '1px solid var(--line-color)',
                            padding: '6px 0px'
                        }} onScroll={(e)=>{
                            let he = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - e.currentTarget.scrollTop
                            // console.log(he);
                            if (he > -10 && he < 10) {
                                mPageNum.current = mPageNum.current + 1;
                                updateList()
                            }
                        }}>
                            {
                                arrayDatas.map(p => {
                                    return <div className={'hovered-gray-radius'}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    onSelectItem(p);
                                                }}
                                                onMouseEnter={(event) => {
                                                    var arrayNew = [...arrayDatas];
                                                    arrayNew.forEach(p => p.isHover = false);
                                                    p.isHover = true;
                                                    showPreview(p);
                                                }}
                                                onMouseLeave={() => {

                                                }}

                                                style={{
                                                    display: "flex",
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    background: p.isHover ? 'var(--popup-cardlist-background-color)' : 'transparent',
                                                    borderRadius: '8px',
                                                    padding: '4px 16px',
                                                    minHeight: '52px',
                                                    margin: '4px 2px',
                                                    overflow: 'hidden'
                                                }}>
                                        <img style={{width: '18px', height: '18px'}}
                                             src={getImagePathWithTheme(p.id == 'createNewCard'?'create_new_card_new':'icon_note')}/>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'column',
                                            marginLeft: '12px',
                                            overflow: 'hidden'
                                        }}>
                                            <span>{p.name}</span>
                                            <span className={'span-single-line'}
                                                  style={{
                                                      color: '#9A9A9C',
                                                      marginTop: '2px'
                                                  }}>{removeHtmlTags(p.thumbHtml)}</span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div className={previewCard?.id == 'createNewCard'?'flex-center':'none'} style={{overflowX: 'hidden', overflowY: 'auto', padding: '16px 16px', marginTop: '6px'}}>
                            {
                                previewCard?.id == 'createNewCard'? <>
                                        <img className={'img-16'} src={getImagePathWithTheme('create_new_card_new')}/>
                                    </> :
                                    <>
                                        <span className={'font-family-semi-bold'}
                                              style={{color: '#4C4C4C'}}>{cardTitle}</span>
                                        <EditorContent id={'editor-small-preview'}
                                                       style={{padding: '0px', fontSize: '12px', marginTop: '12px'}}
                                                       editor={editor}/>
                                    </>
                            }
                        </div>
                    </div>
                    //endregion
                }

                {
                    //region project
                    tabKey == 'project' && false &&
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '260px auto',
                        height: '280px'
                    }}>
                        <div id={'div-popup-project-list'} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            borderRight: '1px solid var(--line-color)',
                            padding: '6px 0px'
                        }}>
                            {
                                arrayProjects.map(p => {
                                    return <div className={'hovered-gray-radius'}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    onSelectItem(p);
                                                }}
                                                onMouseEnter={(event) => {
                                                    var arrayNew = [...arrayProjects];
                                                    arrayNew.forEach(p => p.isHover = false);
                                                    p.isHover = true;
                                                    setSelectProject(p);
                                                }}
                                                onMouseLeave={() => {

                                                }}

                                                style={{
                                                    display: "flex",
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    background: p.isHover ? 'var(--popup-cardlist-background-color)' : 'transparent',
                                                    borderRadius: '8px',
                                                    padding: '4px 16px',
                                                    minHeight: '52px',
                                                    margin: '4px 2px',
                                                    overflow: 'hidden'
                                                }}>
                                        <img style={{width: '18px', height: '18px'}}
                                             src={getImagePathWithTheme('home_bottom_menu_new_project')}/>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'column',
                                            marginLeft: '12px',
                                            overflow: 'hidden'
                                        }}>
                                            <span>{p.name}</span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div className={'flex-column-center'}
                             style={{overflowX: 'hidden', overflowY: 'auto', padding: '16px 16px', marginTop: '6px'}}>
                            <img className={'img-16'} src={getImagePathWithTheme('home_bottom_menu_new_project')}/>
                            <span className={'font-family-semi-bold'}
                                  style={{color: '#4C4C4C', marginTop: '10px'}}>{selectProject?.name}</span>
                        </div>
                    </div>
                    //endregion
                }

                {
                    //region journal
                    // tabKey == 'journal' &&
                    <div style={{
                        display: tabKey == 'journal' ? 'grid' : 'none',
                        gridTemplateColumns: '260px auto',
                        height: '280px',
                    }}>
                        <div id={'div-popup-journal-list'} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            borderRight: '1px solid var(--line-color)',
                            padding: '6px 0px'
                        }}>
                            {
                                arrayJournal.map(p => {
                                    return <div className={'hovered-gray-radius'}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    onSelectItem(p);
                                                }}
                                                onMouseEnter={(event) => {
                                                    var arrayNew = [...arrayJournal];
                                                    arrayNew.forEach(p => p.isHover = false);
                                                    p.isHover = true;
                                                    showPreview(p);
                                                }}
                                                onMouseLeave={() => {

                                                }}

                                                style={{
                                                    display: "flex",
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    background: p.isHover ? 'var(--popup-cardlist-background-color)' : 'transparent',
                                                    borderRadius: '8px',
                                                    padding: '4px 16px',
                                                    minHeight: '52px',
                                                    margin: '4px 2px',
                                                    overflow: 'hidden'
                                                }}>
                                        <img style={{width: '18px', height: '18px'}}
                                             src={getImagePathWithTheme('deeplink_journal')}/>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'column',
                                            marginLeft: '12px',
                                            overflow: 'hidden'
                                        }}>
                                            <span>{p.name}</span>
                                            <span className={'span-single-line'}
                                                  style={{
                                                      color: '#9A9A9C',
                                                      marginTop: '2px'
                                                  }}>{removeHtmlTags(p.thumbHtml)}</span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div style={{overflowX: 'hidden', overflowY: 'auto', padding: '16px 16px', marginTop: '6px'}}>
                            <span className={'font-family-semi-bold'}
                                  style={{color: '#4C4C4C'}}>{selectJournal?.name}</span>
                            <EditorContent id={'editor-small-preview-journal'}
                                           style={{padding: '0px', fontSize: '12px', marginTop: '12px'}}
                                           editor={editorJournal}/>
                        </div>
                    </div>
                    //endregion
                }

                {
                    tabKey == 'project' &&
                    <div style={{
                        height: '270px',
                        overflow:'hidden',
                    }}>
                        <div id={'div-popup-project-list'} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            // borderRight: '1px solid var(--line-color)',
                            padding: '6px 0px 12px 0px'
                        }}>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Tree: {
                                            /* 这里是你的组件 token */
                                            // nodeHoverBg:'#000000',
                                            colorBgContainer:'#000000'
                                        },
                                    },
                                }}
                            >
                                <DirectoryTree
                                    style={{
                                        margin: '8px 0 8px 0px',
                                        height: '300px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        background: isDarkMode()?'#1E1E1E':'transparent',
                                        // border:'1px solid var(--line-color)',
                                        borderRadius:'8px'
                                    }}
                                    className={'overwrite-direction-tree tree-fuck-css-left-align-2-popupcard-list'}
                                    switcherIcon={<Icon component={() => <img className='img-10' style={{marginTop:'2px'}} src={getImagePathWithTheme('tree_icon')}/>}/>}
                                    onSelect={onSelect}
                                    showIcon={false}
                                    treeData={arrayTreeData}
                                    selectedKeys={[]}
                                    blockNode={true}
                                    titleRender={(nodeData: any) => {
                                        return (
                                            <div className='' id={nodeData.key}
                                                 style={{display: "flex", width: "450px", alignItems: "center"}}>
                                                <Input className='default-font-size font-family-regular hovered-text-white'
                                                       readOnly={true} bordered={false}
                                                       style={{
                                                           marginLeft: '0px',
                                                           paddingLeft: '0px',
                                                           whiteSpace: 'nowrap',
                                                           textOverflow: 'ellipsis',
                                                           overflow: 'hidden',
                                                           cursor: "pointer",
                                                           fontSize: '14px',
                                                           marginBottom: '0px',
                                                           marginTop: '0px',
                                                       }}
                                                       value={nodeData.title}/>
                                            </div>
                                        )
                                    }}
                                />
                            </ConfigProvider>
                        </div>
                    </div>
                }

            </div>
        </div>
    ,document.body)
})

export default PopupCardList;




























